import * as React from 'react';
import {TextValue} from 'api/lesson/types';
import LessonBuilderContext
  from 'components/LessonBuilder/LessonBuilderContext';
import CardContext from '../CardContext';
import TextEditor from 'components/TextEditor';

export interface TextTemplateProps {
  value: TextValue;
}

/**
 * This component renders the text template.
 * @param {TextTemplateProps} props
 * @return {React.ReactElement<TextTemplateProps>}
 * @constructor
 */
export default function TextTemplate(
    props: TextTemplateProps,
): React.ReactElement<TextTemplateProps> {
  const cardContext = React.useContext(CardContext);
  const {lesson, setLesson} = React.useContext(LessonBuilderContext);
  const content = lesson?.content || [];

  /**
   * This change event handler.
   * @param {string} value
   */
  function handleChange(value: string): void {
    if (cardContext.index !== undefined) {
      content[cardContext.index].value = value;
      console.log(value);

      (lesson && setLesson) && setLesson({
        ...lesson,
        content,
      });
    }
  }

  return (
    <TextEditor
      defaultValue={props.value}
      onChange={handleChange}
    />
  );
}
